// @flow
import React from 'react';
import { Field } from 'formik';
import { FormGroup, Label, InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { padSAtTheEndIfPlural } from '../../lib/helpers';

type Props = {
  title: string,
  minValue: number,
  disabled: boolean,
  name: string,
  onChange: (value: number) => void,
};

const CustomCounter = ({
  name = 'pax',
  title = '',
  minValue = 1,
  disabled = false,
}: Props) => (
  <Field>
    {({
      field: {
        value: { pax },
      },
      form: { setFieldValue },
    }) => (
      <FormGroup className="cta-input-box" disabled={disabled}>
        {title && <Label className="title">{title}</Label>}
        <InputGroup>
          <InputGroupAddon
            onClick={() => {
              if (pax > minValue) setFieldValue(name, Number(pax) - 1);
            }}
            addonType="prepend"
          >
            <span className="input-group-text">
              <i className="icon icon-hg-minus" />
            </span>
          </InputGroupAddon>

          <Input
            value={`${pax} ${padSAtTheEndIfPlural(pax, 'Trekker')}`}
            type="text"
            readOnly="readyonly"
            min="1"
          />

          <InputGroupAddon
            onClick={() => {
              if (!disabled) setFieldValue(name, Number(pax) + 1);
            }}
            addonType="append"
          >
            <span className="input-group-text">
              <i className="icon icon-hg-plus" />
            </span>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    )}
  </Field>
);

export default CustomCounter;



// WEBPACK FOOTER //
// ./src/components/Counter/CustomCounter.js